import Index from "../view/ProductDetail/Index";
import PageTitle from "../components/PageTitle";
import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.min.css';
import React, { useState, useRef, useEffect } from 'react';
import { json, useNavigate, useParams } from "react-router-dom";
import { setLanguage, setLoading, setLogout } from "../redux/user/user.action";
import { useDispatch, useSelector } from "react-redux";
import ApiCall from "../common/ApiCall";
import { setAvailability, setVisitedList } from "../redux/global/global.action";
import ToastAlert from "../common/ToastAlert";
import helper, { convertEpochToDate, convertToTitleCase, generateCancellationPolicy, getByteLength, getCookie, getLangBySlug, getLinkNameByLang, getSlugByLang, getSlugNameByLang, getTitleNameByLang, isObjectEmpty, revertSlug } from "../common/Helper";
import { AvailabilityResetTime } from "../common/Config";
import { setCartClear, setCartList } from "../redux/cart/cart.action";
// import { ca } from "intl-tel-input/i18n";
import moment from 'moment';
import HomeIcon from "../components/Iocns/HomeIcon";


export default function ProductDetailController() {
    const [isAdultDropBoxVisible, setIsAdultDropBoxVisible] = useState(false);
    const [isDateDropBoxVisible, setIsDateDropBoxVisible] = useState(false);
    const [isTimeDropBoxVisible, setIsTimeDropBoxVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isSimilarTourLoading, setIsSimilarTourLoading] = useState(false);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [realExpMapLoaded, setRealExpMapLoaded] = useState(false);
    const [routeMapLoaded, setRouteMapLoaded] = useState(false);
    const [date, setDate] = useState();
    const adultDropBoxRef = useRef(null);
    const dateDropBoxRef = useRef(null);
    const timeDropBoxRef = useRef(null);
    const calendarRef = useRef();
    const [recordDetail, setRecordDetail] = useState({})
    const perems = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);
    const global = useSelector((state) => state.global);
    const cart = useSelector((state) => state.cart);
    const [breadcrumbList, setBreadcrumbList] = useState([])
    const [isProductLiked, setIsProductLiked] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const descriptionRef = useRef(null);
    const [isAdminLoggedin, setIsAdminLoggedin] = useState(false);
    const [companyDetail, setCompanyDetail] = useState({})
    const [supplierDetail, setSupplierDetail] = useState({})
    const [activeKey, setActiveKey] = useState(["0"]); // Default open item
    const availability = global?.availablity
    const availabilityRef = useRef(availability)
    const [productAvailability, setProductAvailability] = useState('[]');
    const [flatpickrInstance, setFlatpickrInstance] = useState(null);
    const [startTimes, setStartTimes] = useState('[]');
    const [dateSchedule, setDateSchedule] = useState([]);
    const [slotNotAvailabel, setSlotNotAvailabel] = useState('');
    let lastMonth = null
    let lastYear = null
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [isAvailabilityLoading, setIsAvailabilityLoading] = useState(false);
    const [productPricingCategories, setProductPricingCategories] = useState([])

    const [userCartData, setUserCartData] = useState([])
    const [ratesList, setRatesList] = useState([])

    const [selectedTime, setSelectedTime] = useState(null);
    const [selectedRate, setSelectedRate] = useState(null);
    const [similarTours, setSimilarTours] = useState([]);
    const [cancellationPolicy, setCancellationPolicy] = useState('');
    const [metaTitle, setMetaTitle] = useState('Toursxplorer');
    const pricingRef = useRef()
    const tieredPricingRef = useRef()
    const [locationDetail, setLocationDetail] = useState(null);
    const slugLinkField = getLinkNameByLang(user?.language)
    const slugLang = getSlugByLang(user?.language)

    const [productList, setProductList] = useState([]);
    const [supplierProductNextPageUrl, setsupplierProductNextPageUrl] = useState('');
    const [isSupplierProductLoading, setIsSupplierProductLoading] = useState(false);

    const [pickupList, setPickupList] = useState([]);
    const [pickupNextPageUrl, setpickupNextPageUrl] = useState('');
    const [isPickupLoading, setIsPickupLoading] = useState(false);
    const [disableButtons, setDisableButtons] = useState(false);



    const [isDefLoading, setIsDefLoading] = useState(false);
    const [isDefLoadingPickup, setIsDefLoadingPickup] = useState(false);

    const today = moment().format('YYYY-MM-DD');
    const [showAllPlaces, setShowAllPlaces] = useState(false);
    const isProcessingRef = useRef(false);

    const getSupplierTourList = async (page = null, slug = null) => {
        let data = {}
        var slugField = "";
        let lang = getLangBySlug(slug ? slug : perems?.lang)
        slugField = getSlugNameByLang(lang)
        data.page = page;
        data.supplier_id = recordDetail?.supplier_id;
        data.id = recordDetail?.id;
        data.slug = slug ? slug : recordDetail?.slug;
        data.field = slugField
        data.alreadyLoadedIds = JSON.stringify(productList.map((item) => item?.id))



        if (page == null) {
            setIsDefLoading(true)
        } else {

            setIsSupplierProductLoading(true)
        }

        const getList = await ApiCall('post', 'supplier-tours', data)

        setIsSupplierProductLoading(false)
        setIsDefLoading(false)

        if (getList) {
            if (getList?.data?.success) {
                if (page == null) {
                    setProductList(getList.data.data.products)
                } else {
                    setProductList(prevProducts => [...prevProducts, ...getList.data.data.products]);
                }

                setsupplierProductNextPageUrl(getList.data.data.supplier_product_next_page_url)
            }
        }
    }

    const onClickLoadMore = async (type, page) => {
        await getSupplierTourList(page)
    }

    const getPickupList = async (page = null) => {
        let data = {}
        data.page = page;
        data.id = recordDetail?.id;

        if (page == null) {
            setIsDefLoadingPickup(true)
        } else {

            setIsPickupLoading(true)
        }

        const getList = await ApiCall('post', 'product-pickup-places', data)

        setIsPickupLoading(false)
        setIsDefLoadingPickup(false)

        if (getList) {
            if (getList?.data?.success) {
                if (page == null) {
                    setPickupList(getList.data.data.places)
                } else {
                    setPickupList(prev => [...prev, ...getList.data.data.places]);
                }

                setpickupNextPageUrl(getList.data.data.pickup_next_page_url)
            }
        }
    }

    const onClickLoadMorePickup = async (page) => {
        await getPickupList(page)
    }


    useEffect(() => {
        availabilityRef.current = availability;
        return () => {
            // console.log('cleanup');
        };
    }, [availability]);

    const closeAccordion = () => {
        setActiveKey([]); // Close all accordions
    };


    const displayAvailableTime = (date) => {


        const timeData = availabilityRef.current ? JSON.parse(availabilityRef.current) : [];

        let selectedDatesTimes = timeData.filter((e) => e.date === Number(date));
        // console.log(selectedDatesTimes);

        setDateSchedule(selectedDatesTimes)
        // if (selectedDatesTimes.length > 0) {

        //     // const startTimesAry = startTimes ? JSON.parse(startTimes) : [];

        //     const groupedByStartTime = selectedDatesTimes.reduce((acc, record) => {
        //         const startTimeLabel = record.startTime;
        //         if (!acc[startTimeLabel]) {
        //             acc[startTimeLabel] = [];
        //         }
        //         acc[startTimeLabel].push(record);
        //         return acc;
        //     }, {});

        //     console.log(groupedByStartTime);


        //     setDateSchedule(groupedByStartTime)

        // }



    }


    const toggleDropBox = (type) => {

        var dropdownContent;
        if (type == 'age') {
            dropdownContent = adultDropBoxRef.current;
            setIsAdultDropBoxVisible(!isAdultDropBoxVisible)
        }
        if (type == 'date') {
            if (calendarRef.current) {
                flatpickr(calendarRef.current, {
                    mode: "range",
                    inline: true,
                    dateFormat: 'Y-m-d',
                    onChange: (selectedDates) => setDate(selectedDates[0]),
                    appendTo: calendarRef.current,
                });
            }
            dropdownContent = dateDropBoxRef.current;
            setIsDateDropBoxVisible(!isDateDropBoxVisible)
        }

        if (type == 'time') {
            dropdownContent = timeDropBoxRef.current;
            setIsTimeDropBoxVisible(!isTimeDropBoxVisible)
        }

        if (dropdownContent.classList.contains("open")) {
            dropdownContent.classList.remove("open");
            dropdownContent.classList.add("close");
            setTimeout(() => {
                dropdownContent.style.display = "none";
            }, 300);
        } else {
            dropdownContent.classList.remove("close");
            dropdownContent.style.display = "block";
            dropdownContent.classList.add("open");
        }
    };


    const handleOutsideClick = (event) => {
        if (isAdultDropBoxVisible && adultDropBoxRef.current &&
            !adultDropBoxRef.current.contains(event.target) &&
            !event.target.closest(".firstBoxClick")) {

            if (isAdultDropBoxVisible) {
                toggleDropBox('age');
            }
        }

        if (isDateDropBoxVisible && dateDropBoxRef.current &&
            !dateDropBoxRef.current.contains(event.target) &&
            !event.target.closest(".secondBoxClick")) {

            if (isDateDropBoxVisible) {
                toggleDropBox('date');
            }
        }


        if (isTimeDropBoxVisible && timeDropBoxRef.current &&
            !timeDropBoxRef.current.contains(event.target) &&
            !event.target.closest(".thirdBoxClick")) {

            if (isTimeDropBoxVisible) {
                toggleDropBox('time');
            }
        }


    };

    // const toggleMap = () => {
    //     const mapBox = document.querySelector('.mapBox');
    //     const button = document.querySelector('.btnMap');

    //     if (mapBox.style.opacity === '0') {
    //         mapBox.style.opacity = '1';
    //         mapBox.style.maxHeight = '300px';
    //         button.textContent = 'Hide Map';
    //         setMapLoaded(true)
    //     } else {
    //         mapBox.style.opacity = '0';
    //         mapBox.style.maxHeight = '0';
    //         button.textContent = 'Show Me In The Map';
    //         setMapLoaded(false)
    //     }
    // }
    const toggleMap = () => {
        const mapBox = document.querySelector(".mapBox");
        const button = document.querySelector("#btnMap");

        if (mapBox.style.opacity === "0") {
            mapBox.style.opacity = "1";
            mapBox.style.maxHeight = "300px";
            mapBox.style.display = "block";
            button.textContent = "Hide Map";
            setMapLoaded(true);
        } else {
            mapBox.style.opacity = "0";
            mapBox.style.maxHeight = "0";
            setTimeout(() => {
                mapBox.style.display = "none"; // Hide after transition
            }, 500);
            button.textContent = "Show Me In The Map";
        }
    };

    const toggleRealExpMap = () => {
        const mapBox = document.querySelector(".realExpMapBox");
        const button = document.querySelector("#btnRealExpMap");

        if (mapBox.style.opacity === "0") {
            mapBox.style.opacity = "1";
            mapBox.style.maxHeight = "300px";
            mapBox.style.display = "block";
            button.textContent = "Hide Map";
            setRealExpMapLoaded(true);
        } else {
            mapBox.style.opacity = "0";
            mapBox.style.maxHeight = "0";
            setTimeout(() => {
                mapBox.style.display = "none"; // Hide after transition
            }, 500);
            button.textContent = "Show Me In The Map";
        }
    };

    const toggleRouteMap = () => {
        const mapBox = document.querySelector(".routeMapBox");
        const button = document.querySelector("#btnRouteMap");

        if (mapBox.style.opacity === "0") {
            mapBox.style.opacity = "1";
            mapBox.style.maxHeight = "300px";
            mapBox.style.display = "block";
            button.textContent = "Hide Itinerary Map";
            setRouteMapLoaded(true);
        } else {
            mapBox.style.opacity = "0";
            mapBox.style.maxHeight = "0";
            setTimeout(() => {
                mapBox.style.display = "none"; // Hide after transition
            }, 500);
            button.textContent = "Itinerary Map here";
        }
    };

    const togglePlace = () => {
        const mapBox = document.querySelector(".pickup_box");
        const button = document.querySelector("#btnPlace");

        if (mapBox.style.opacity === "0") {
            mapBox.style.opacity = "1";
            mapBox.style.maxHeight = "300px";
            // mapBox.style.display = "block";
            button.textContent = "Hide Places";
        } else {
            mapBox.style.opacity = "0";
            mapBox.style.maxHeight = "0";
            // setTimeout(() => {
            //     mapBox.style.display = "none"; // Hide after transition
            // }, 500);
            button.textContent = "Show Places";
        }
    };

    const getRecordDetails = async (slug, cookie = null) => {
        // setIsAvailabilityLoading(true)
        setIsLoading(true)
        var slugField = "";

        // if (perems?.lang && user?.language != 'English') {
        let lang = getLangBySlug(perems?.lang)
        slugField = getSlugNameByLang(lang)


        // console.log(user?.language);
        // console.log('lang', lang);




        if (user?.language != lang) {
            dispatch(setLanguage(lang))

        }
        const select = document.querySelector('.goog-te-combo');
        if (select) {
            let glang = getLangBySlug(select?.value)

            if (user?.language != glang) {
                select.value = perems?.lang == 'pt' ? 'pt-PT' : perems?.lang; // target language (English)
                select.dispatchEvent(new Event('change'));
            }
        }
        // }
        let data = {};
        data.slug = slug
        data.cookieToken = cookie
        data.field = slugField
        data.userId = user?.userDetails?.id ? user?.userDetails?.id : null
        const fetchrecordDetail = await ApiCall('post', 'product-detail', data)
        setIsLoading(false)
        if (fetchrecordDetail) {
            if (fetchrecordDetail?.data?.success) {
                setIsAdminLoggedin(fetchrecordDetail.data.isAdmin)
                setIsProductLiked(fetchrecordDetail.data.liked)
                setRecordDetail(fetchrecordDetail.data.data)
                setSupplierDetail(fetchrecordDetail.data.supplierDetail)
                setCompanyDetail(fetchrecordDetail.data.companyDetail)
                setMetaTitle(fetchrecordDetail.data.data?.title)

                setLocationDetail(fetchrecordDetail?.data?.locationDetail)
                setProductPricingCategories(fetchrecordDetail.data?.data?.product_pricing_categories)

                const productLocation = fetchrecordDetail?.data.data.product_detail?.meeting_point_location ? JSON.parse(fetchrecordDetail?.data.data.product_detail?.meeting_point_location) : [];
                let locationBreadCrumb = fetchrecordDetail?.data?.locationDetail

                // console.log('test',slugLinkField);

                let breadCrmb = [
                    {
                        name: <HomeIcon />,
                        url: (slugLang ? ('/' + slugLang) : '/en')
                    }
                ];
                if (locationBreadCrumb.length > 0) {
                    locationBreadCrumb.map((loc, i) => {
                        breadCrmb.push({
                            name: loc.name,
                            // url: '/location' + loc.link
                            url: (slugLang ? ('/' + slugLang) : '') + '/location' + loc?.[slugLinkField]

                        })
                    })
                    setBreadcrumbList(breadCrmb)
                } else {
                    if (productLocation && productLocation.length > 0) {
                        productLocation.map((loc, i) => {
                            breadCrmb.push({
                                name: loc,
                            })
                        })
                    } else {
                        breadCrmb.push({
                            name: fetchrecordDetail.data.data?.title,
                        })
                    }
                    setBreadcrumbList(breadCrmb)
                }
                // let url = ary?.length > 0 ? '/location' : '';

                // setBreadcrumbList(breadCrmb)


            } else {
                if (fetchrecordDetail?.data?.message == 'Unauthorized' || fetchrecordDetail?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + slugLang + '/login')
                } else {
                    navigate('/' + slugLang)
                    // navigate('/')
                }

            }
        }
    }

    const storeUserProductVisit = async (id) => {
        const storeVisit = await ApiCall('post', 'store-product-visit', { product_id: id, type: 'LIVE' }, user.token)
    }

    function storeGuestUserProductVisit(id) {
        const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000);
        let localVisit = global.visitedList ? JSON.parse(global.visitedList) : [];

        const productRecords = localVisit.filter(record => record.product_id === id);

        // Check if all records for that product are older than 5 minutes
        const allOlderThanFiveMinutes = productRecords.every(record => new Date(record.time) < fiveMinutesAgo);

        if (allOlderThanFiveMinutes) {
            // Insert new record for the given product_id
            const newRecord = { time: new Date(), product_id: id };
            localVisit.push(newRecord);
            dispatch(setVisitedList(JSON.stringify(localVisit)));

            console.log('New record inserted:', newRecord);
        } else {

            console.log('Record(s) for product_id', id, 'are not older than 5 minutes');
        }

    }

    const getSimilarTours = async (slug) => {
        setIsSimilarTourLoading(true)
        let data = {};
        const slugField = getSlugNameByLang(user?.language)
        data.slug = slug
        data.user_id = user?.userDetails?.id ? user?.userDetails?.id : null
        data.field = slugField
        const fetchrecordDetail = await ApiCall('post', 'similar-tours', data)
        setIsSimilarTourLoading(false)
        if (fetchrecordDetail) {
            if (fetchrecordDetail?.data?.success) {
                setSimilarTours(fetchrecordDetail.data.products)
            } else {
                if (fetchrecordDetail?.data?.message == 'Unauthorized' || fetchrecordDetail?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + slugLang + '/login')
                } else {
                    // navigate(-1)
                }

            }
        }
    }

    const handleSeePlacesMoreClick = () => {
        setShowAllPlaces(true); // Show all categories
    };

    const handleSeePlacesLessClick = () => {
        setShowAllPlaces(false); // Show only the first 4 categories
    };


    // useEffect(() => {
    //     if (isAdultDropBoxVisible || isDateDropBoxVisible || isTimeDropBoxVisible) {
    //         document.addEventListener("click", handleOutsideClick);
    //     } else {
    //         document.removeEventListener("click", handleOutsideClick);
    //     }
    //     return () => {
    //         document.removeEventListener("click", handleOutsideClick);
    //     };
    // }, [isAdultDropBoxVisible, isDateDropBoxVisible, isTimeDropBoxVisible]);


    // useEffect(() => {
    //     if (calendarRef.current) {
    //         flatpickr(calendarRef.current, {
    //             // mode: "range",
    //             inline: true,
    //             dateFormat: 'Y-m-d',
    //             onChange: function (selectedDates, dateStr, instance) {

    //                 setDate(dateStr)
    //                 setActiveKey(["1"])


    //             },
    //             appendTo: calendarRef.current,
    //         });
    //     }
    // }, [calendarRef.current]);


    useEffect(() => {

        setRecordDetail(null)
        setDate(null);
        setSelectedRate(null);
        setSelectedTime(null);
        setRatesList([])
        setDateSchedule([]);
        setActiveKey(['0'])
        setPickupList([])
        setUserCartData([])
        availabilityRef.current = null;
        dispatch(setAvailability(JSON.stringify([])))
        dispatch(setCartClear())
        setDisableButtons(false);
        setExpanded(false);
        setIsOverflowing(false)

        return () => {
            console.log('cleanup');
        };
    }, [perems.slug]);

    useEffect(() => {
        (async () => {
            if (perems.slug) {
                await getRecordDetails(perems.slug, getCookie("is_admin_logged_in"))
                await getSupplierTourList(null, perems.slug)
                await getSimilarTours(perems.slug)

            }
        })();
        return () => {
            console.log('cleanup');
        };
    }, [perems.slug, getCookie("is_admin_logged_in")]);

    useEffect(() => {
        (async () => {
            if (recordDetail?.id) {
                // await getSupplierTourList(null)
                await getPickupList(null)


            }
        })();
        return () => {
            console.log('cleanup');
        };
    }, [recordDetail?.id]);

    useEffect(() => {

        if (user?.language != "Other") {

            setMetaTitle(recordDetail?.[getTitleNameByLang(user?.language)])

            const slugField = getSlugNameByLang(user?.language)
            const slugLang = getSlugByLang(user?.language)

            if (slugField && recordDetail?.[slugField]) {
                // window.history.replaceState(null, "", (slugLang ? ('/' + slugLang) : '') + '/tour/' + recordDetail?.[slugField]);
                window.history.pushState(null, "", (slugLang ? ('/' + slugLang) : '') + '/tour/' + recordDetail?.[slugField]);

            }
        }

        return () => {
            console.log('cleanup');
        };

    }, [user?.language, recordDetail]);


    useEffect(() => {
        (async () => {
            if (recordDetail?.id && user.token) {
                await storeUserProductVisit(recordDetail?.id)
            }
            if (recordDetail?.id && !user.token) {
                storeGuestUserProductVisit(recordDetail?.id)
            }
        })();
        return () => {
            console.log('cleanup');
        };
    }, [recordDetail, user.token]);

    const toggleLike = async (isLiked) => {
        if (!user.token) {
            navigate('/' + slugLang + '/login')
        }
        setIsProductLiked(isLiked)
        let data = {};
        data.product_id = recordDetail?.id
        data.isLiked = isLiked

        const likeUnlikeProduct = await ApiCall('post', 'toggle-product-like', data, user.token)
        if (likeUnlikeProduct) {

            if (likeUnlikeProduct?.data?.success) {

            } else {
                if (likeUnlikeProduct?.data?.message == 'Unauthorized' || likeUnlikeProduct?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + slugLang + '/login')
                }
            }
        }

    }

    // const onClickShareIcon = () => {
    //     const url = window.location.href;
    //     navigator.clipboard.writeText(url);
    //     ToastAlert({ msg: "Link copied to clipboard!", msgType: "info" });

    // }
    const onClickShareIcon = () => {
        const url = window.location.href;

        // Check if Web Share API is available (mostly on mobile browsers)
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: "Check this out!",
                url: url,
            })
                .then(() => {
                    console.log("Shared successfully");
                    // ToastAlert({ msg: "Link shared successfully!", msgType: "info" });
                })
                .catch((error) => {
                    console.error("Error sharing:", error);
                    // ToastAlert({ msg: "Failed to share link.", msgType: "error" });
                });
        } else {
            // Fallback for desktop
            navigator.clipboard.writeText(url);
            ToastAlert({ msg: "Link copied to clipboard!", msgType: "info" });
        }
    };


    useEffect(() => {
        if (descriptionRef.current) {
            setIsOverflowing(descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight);
        }
        return () => {
            console.log('cleanup');
        };
    }, [recordDetail?.full_description]);





    // function getCookie(name) {
    //     let cookieArr = document.cookie.split("; ");
    //     for (let cookie of cookieArr) {
    //         let [cookieName, cookieValue] = cookie.split("=");
    //         if (cookieName === name) {
    //             return decodeURIComponent(cookieValue);
    //         }
    //     }
    //     return null;
    // }

    // console.log('is_admin_logged_in', getCookie("is_admin_logged_in"));
    // useEffect(() => {
    //     if (getCookie("is_admin_logged_in") != null) {
    //         // setIsAdminLoggedin(true)
    //     }

    // }, [getCookie("is_admin_logged_in")]);


    function getUniqueDateAry(Datearray) {
        const uniqueDates = [];
        const seenDates = new Set();
        const timeData = availabilityRef.current ? JSON.parse(availabilityRef.current) : [];
        // console.log('Datearray',Datearray);


        Datearray.forEach((activity) => {
            if (!seenDates.has(activity.date)) {
                // Check if all records with the same date have soldOut: true
                const isSoldOut = Datearray
                    .filter((item) => item.date === activity.date)
                    .every((item) => item.soldOut === true);

                let selectedDatesTimes = timeData.filter((e) => e.date === Number(activity.date));
                selectedDatesTimes = selectedDatesTimes.map((e) => e.startTime)

                uniqueDates.push({
                    epoch: activity.date,
                    date: convertEpochToDate(activity.date), // Ensure convertEpochToDate is defined in your React component
                    soldOut: isSoldOut,
                    selectedDatesTimes: selectedDatesTimes,

                });

                seenDates.add(activity.date);
            }
        });

        return uniqueDates;
    }


    function highlightDates(instance, highlightedDates = []) {


        highlightedDates.forEach(date => {

            // const formattedDate = instance.formatDate(new Date(date.date), "F j, Y");
            // console.log('formattedDate',formattedDate);

            // const safeDate = new Date(date.date.includes('T') ? date.date : `${date.date}T00:00:00`);
            // console.log('formattedDate safeDate',safeDate);

            // const formattedDate2 = instance.formatDate(safeDate, "F j, Y");
            // console.log('formattedDate2',formattedDate2);
            let safeDate;

            if (typeof date.date === "string") {
                const [yearStr, monthStr, dayStr] = date.date.trim().split("-");
                const year = parseInt(yearStr, 10);
                const month = parseInt(monthStr, 10);
                const day = parseInt(dayStr, 10);

                if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
                    safeDate = new Date(year, month - 1, day); // SAFARI-SAFE ✅
                }
            }

            if (!safeDate || isNaN(safeDate.getTime())) {
                console.warn("Invalid or unparsable date:", date.date);
                return;
            }

            const formattedDate = instance.formatDate(safeDate, "F j, Y");
            console.log('formattedDate', formattedDate);


            const dayElement = instance.calendarContainer.querySelector(
                `[aria-label="${formattedDate}"]`
            );
            if (dayElement) {
                dayElement.setAttribute("data-epoch", date.epoch);
                // if (date.selectedDatesTimes && date.selectedDatesTimes.length > 0) {
                //     const tooltipText = date.selectedDatesTimes.join(", ");
                //     dayElement.setAttribute("title", tooltipText); // Tooltip on hover
                // }
                if (Array.isArray(date.selectedDatesTimes) && date.selectedDatesTimes.length > 0) {
                    const tooltipText = `${date.selectedDatesTimes.join(", ")}`;

                    // Bootstrap tooltip
                    dayElement.setAttribute("data-bs-toggle", "tooltip");
                    dayElement.setAttribute("data-bs-placement", "top");
                    dayElement.setAttribute("title", tooltipText);


                    // setTimeout(() => {
                    //     const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                    //     tooltipTriggerList.forEach((tooltipEl) => {
                    //         new window.bootstrap.Tooltip(tooltipEl); // Initialize Bootstrap tooltip
                    //     });
                    // }, 100);


                    setTimeout(() => {
                        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                        if (instance?.calendarContainer) {
                            tooltipTriggerList.forEach((tooltipEl) => {
                                const tooltip = new window.bootstrap.Tooltip(tooltipEl, {
                                    container: instance?.calendarContainer, // Attach tooltips inside Flatpickr calendar
                                    trigger: 'hover', // Only show on hover
                                    boundary: 'window', // Keep tooltips within viewport
                                });

                                tooltipEl.addEventListener('click', () => {
                                    tooltip.hide(); // Hide tooltip when clicking a date
                                });
                            });
                        }
                    }, 100);
                }

                if (date.soldOut == true) {
                    dayElement.classList.add("soldout-date", "bookable-date");
                } else {
                    dayElement.classList.add("available-date", "bookable-date");
                }
            }
        });
    }


    const getProductAvailability = async (year = null, month = null) => {
        // setIsAvailabilityLoading(true)
        let data = {}
        data.id = recordDetail?.id
        data.type = recordDetail?.tour_provider
        data.tour_provider_product_id = recordDetail?.tour_provider_product_id
        data.year = year
        data.month = month
        const productAvailability = await ApiCall('post', 'product-availability', data)
        // setIsAvailabilityLoading(false)
        if (productAvailability && productAvailability?.data?.success) {
            // pricingRef.current = JSON.stringify(productAvailability.data.productPricing)
            // return productAvailability.data.productAvailability.data
            return {
                availability: productAvailability.data.productAvailability.data,
                pricing: JSON.stringify(productAvailability.data.productPricing),
                tieredPricing: JSON.stringify(productAvailability.data.productTieredPricing)
            };
        }
        return {
            availability: null,
            pricing: null,
            tieredPricing: null,
        };
    }

    const fillAvailablitySchedule = (data = null, ucDta = null) => {
        let availDta = data ? data : availabilityRef?.current
        const jsonData = availDta ? JSON.parse(availDta) : [];
        const uniqueDates = getUniqueDateAry(jsonData);


        if (flatpickrInstance) {
            flatpickrInstance?.destroy();
        }

        const currentMonth = new Date().getMonth() + 2; // 0-indexed (Jan = 0)
        const currentYear = new Date().getFullYear();
        // localStorage.setItem("selectedMonth", currentMonth + 1);
        // localStorage.setItem("selectedYear", currentYear);

        const defaultMonth = selectedMonth !== null ? selectedMonth : new Date().getMonth() + 1
        const defaultYear = selectedYear !== null ? selectedYear : new Date().getFullYear()

        // console.log('defaultMonth', defaultMonth);
        // console.log('defaultYear', defaultYear);



        const instance = flatpickr(calendarRef?.current, {
            showMonths: 1,
            dateFormat: "Y-m-d",
            inline: true,
            minDate: new Date().setDate(1),
            locale: {
                firstDayOfWeek: 1,
            },
            // defaultMonth: selectedMonth !== null ? selectedMonth : new Date().getMonth() + 1,
            // defaultYear: selectedYear !== null ? selectedYear : new Date().getFullYear(),
            // defaultMonth: "03",
            // defaultYear: defaultYear,
            defaultDate: `${defaultYear}-${defaultMonth}-${"01"}`,
            monthSelectorType: 'static',
            yearSelectorType: 'static',

            // enableTime:false

            onReady: function (selectedDates, dateStr, instance) {
                // instance.clear();
                instance.setDate(null, false);
                instance.input.style.display = 'none';
                highlightDates(instance, uniqueDates);

            },

            onChange: function (selectedDates, dateStr, instance) {
                setDate(dateStr)
                setSelectedRate(null)
                setSelectedTime(null)
                setDateSchedule([])
                setSelectedRate(null)
                setRatesList([])

                setActiveKey(["0", "1", "2"])

                const dta = availabilityRef?.current ? JSON.parse(availabilityRef?.current) : [];
                let uniqD = getUniqueDateAry(dta)
                highlightDates(instance, uniqD);

                const selectedDate = selectedDates[0];
                const formattedDate = instance.formatDate(selectedDate, "F j, Y");


                const dayElement = instance.calendarContainer.querySelector(
                    `[aria-label="${formattedDate}"]`
                );


                if (dayElement) {

                    const epocValue = dayElement.getAttribute("data-epoch");

                    if (epocValue) {
                        setSlotNotAvailabel('')
                        displayAvailableTime(epocValue);
                    } else {
                        setSlotNotAvailabel(formattedDate)
                    }
                }


            },

            onMonthChange: function (selectedDates, dateStr, instance) {
                setDate(null)
                setSelectedRate(null)
                setSelectedTime(null)
                setSelectedRate(null)
                setRatesList([])

                setDateSchedule([])
                setSlotNotAvailabel('')
                const currentMonth = instance.currentMonth + 1; // Months are zero-based
                const currentYear = instance.currentYear;


                if (instance.currentMonthNavDisabled) {
                    instance.changeMonth(new Date().getMonth() - instance.currentMonth);
                }

                // Only trigger the API call if the month or year has actually changed

                (async () => {
                    try {

                        if (currentMonth !== lastMonth || currentYear !== lastYear) {

                            // localStorage.setItem("selectedMonth", currentMonth);
                            // localStorage.setItem("selectedYear", currentYear);
                            // console.log('currentMonth', currentMonth);


                            lastMonth = currentMonth;
                            lastYear = currentYear;
                            setSelectedMonth(currentMonth);
                            setSelectedYear(currentYear);
                            setIsAvailabilityLoading(true)
                            const productId = recordDetail?.id;
                            let storedData = JSON.parse(localStorage.getItem('productAvailability')) || {};

                            const { availability, pricing, tieredPricing } = await getProductAvailability(currentYear, currentMonth);
                            setIsAvailabilityLoading(false)
                            let seats = ucDta ? ucDta : userCartData;
                            if (availability && pricing) {
                                storedData[productId] = {
                                    availability,
                                    pricing,
                                    timestamp: Date.now(),
                                    selectedMonth: currentMonth,
                                    selectedYear: currentYear
                                };
                                pricingRef.current = pricing
                                tieredPricingRef.current = tieredPricing


                                // console.log('result', JSON.parse(availability));
                                // console.log('seats', seats);

                                const result = filterRecords(JSON.parse(availability), seats);

                                // console.log('result ==', result);


                                availabilityRef.current = JSON.stringify(result)
                                // dispatch(setAvailability(JSON.stringify(result)))

                                let uniqDate = getUniqueDateAry(result);
                                highlightDates(instance, uniqDate);

                                localStorage.setItem('productAvailability', JSON.stringify(storedData));

                            }
                        }

                    } catch (error) {
                        // console.error(error); // Handle error
                    }
                })();
            },

            onYearChange: function (selectedDates, dateStr, instance) {
                setDate(null)
                setSelectedRate(null)
                setSelectedTime(null)
                setSelectedRate(null)
                setRatesList([])
                setDateSchedule([]);
                setSlotNotAvailabel('');
                const currentMonth = instance.currentMonth + 1;
                const currentYear = instance.currentYear;

                setSelectedMonth(currentMonth);
                setSelectedYear(currentYear);

                // localStorage.setItem("selectedMonth", currentMonth);
                // localStorage.setItem("selectedYear", currentYear);

                (async () => {
                    try {
                        setIsAvailabilityLoading(true)
                        const productId = recordDetail?.id;
                        let storedData = JSON.parse(localStorage.getItem('productAvailability')) || {};

                        const { availability, pricing, tieredPricing } = await getProductAvailability(currentYear, currentMonth);
                        setIsAvailabilityLoading(false)
                        let seats = ucDta ? ucDta : userCartData;
                        if (availability && pricing) {
                            storedData[productId] = {
                                availability,
                                pricing,
                                timestamp: Date.now(),
                                selectedMonth: currentMonth,
                                selectedYear: currentYear
                            };
                            pricingRef.current = pricing
                            tieredPricingRef.current = tieredPricing


                            const result = filterRecords(JSON.parse(availability), seats);

                            dispatch(setAvailability(JSON.stringify(result)))

                            let uniqDate = getUniqueDateAry(result);
                            highlightDates(instance, uniqDate);

                            localStorage.setItem('productAvailability', JSON.stringify(storedData));

                        }
                    } catch (error) {
                        // console.error(error);
                    }
                })();
            },
        });

        setFlatpickrInstance(instance);
    };

    const resetCalendar = (cart = null) => {
        if (flatpickrInstance) {
            flatpickrInstance.destroy(); // Destroy the existing instance
        }

        setDate(null); // Reset selected date
        setDateSchedule([]); // Clear scheduled data
        setSlotNotAvailabel(""); // Reset slot availability
        fillAvailablitySchedule(null, cart); // Re-initialize Flatpickr with highlighted dates
        // Re-initialize Flatpickr without highlighted dates
        // setFlatpickrInstance(
        //     flatpickr(calendarRef?.current, {
        //         showMonths: 1,
        //         dateFormat: "Y-m-d",
        //         inline: true,
        //         minDate: new Date().setDate(1),
        //         locale: {
        //             firstDayOfWeek: 1,
        //         },
        //         defaultMonth: new Date().getMonth(),
        //         defaultYear: new Date().getFullYear(),
        //         monthSelectorType: 'static',
        //         yearSelectorType: 'static',
        //         onReady: (selectedDates, dateStr, instance) => {
        //             instance.input.style.display = 'none';
        //         }
        //     })
        // );
    };
    // useEffect(() => {
    //     setFlatpickrInstance(
    //         flatpickr(calendarRef?.current, {
    //             showMonths: 1,
    //             dateFormat: "Y-m-d",
    //             inline: true,
    //             minDate: new Date().setDate(1),
    //             locale: {
    //                 firstDayOfWeek: 1,
    //             },
    //             defaultMonth: new Date().getMonth(),
    //             defaultYear: new Date().getFullYear(),
    //             monthSelectorType: 'static',
    //             yearSelectorType: 'static',
    //             onReady: (selectedDates, dateStr, instance) => {
    //                 instance.input.style.display = 'none';
    //             }
    //         })
    //     );

    // }, [calendarRef?.current]);

    // useEffect(() => {

    //     (async () => {

    //         if (recordDetail?.id && recordDetail?.tour_provider_product_id) {
    //             setDateSchedule([])
    //             let data = await getProductAvailability()
    //             dispatch(setAvailability(data))
    //             fillAvailablitySchedule(data)
    //         }
    //     })();

    // }, [recordDetail?.id, recordDetail?.tour_provider_product_id]);

    // useEffect(() => {
    //     if (!isAvailabilityLoading && calendarRef.current) {
    //         fillAvailablitySchedule(availabilityRef?.current);
    //     }
    // }, [isAvailabilityLoading, calendarRef.current]); // Run when loading completes & ref is available



    const toggleAccordion = (key) => {
        let actKeys = [...activeKey]
        if (actKeys.includes(key)) {
            var index = actKeys.indexOf(key);
            if (index !== -1) {
                actKeys.splice(index, 1);
            }
        } else {
            actKeys.push(key)
        }
        setActiveKey(actKeys)
        // setActiveKey((prev) => (prev.includes(key) ? [] : [key]));
    };

    // function filterRecords(main, cartarray) {
    //     return main.filter(item => {
    //         return item.rates.some(rate => {
    //             // Check if all catIds in cartarray exist in pricingCategoryIds
    //             const hasAllCategories = cartarray.every(cartItem => 
    //                 rate.pricingCategoryIds.includes(cartItem.catId)
    //             );

    //             // Calculate total quantity in cartarray
    //             const totalQty = cartarray.reduce((sum, cartItem) => sum + cartItem.qty, 0);

    //             // Check if total quantity does not exceed maxPerBooking
    //             return hasAllCategories && totalQty <= rate.maxPerBooking;
    //         });
    //     });
    // }

    // function filterRecords(main, cartarray) {
    //     return main
    //         .map(item => {
    //             // Filter rates that match conditions
    //             const matchingRates = item.rates.filter(rate => {
    //                 // Check if all catIds in cartarray exist in pricingCategoryIds
    //                 const hasAllCategories = cartarray.every(cartItem =>
    //                     rate.pricingCategoryIds.includes(cartItem.catId)
    //                 );

    //                 // Calculate total quantity in cartarray
    //                 const totalQty = cartarray.reduce((sum, cartItem) => sum + cartItem.qty, 0);

    //                 // Check if total quantity does not exceed maxPerBooking
    //                 return hasAllCategories && totalQty <= rate.maxPerBooking;
    //             });

    //             // If at least one matching rate is found, return the modified object
    //             return matchingRates.length > 0 ? { ...item, rates: matchingRates } : null;
    //         })
    //         .filter(item => item !== null); // Remove null values (items with no matching rates)
    // }

    function filterRecords_(main, cartarray) {
        return main
            .map(item => {
                // Filter rates that match conditions
                const matchingRates = item?.rates?.filter(rate => {
                    // Ensure all categories in cartarray exist in rate's pricingCategoryIds
                    const hasAllCategories = cartarray.every(cartItem =>
                        rate.pricingCategoryIds.includes(cartItem.catId)
                    );

                    // Sum only quantities for categories present in the current rate
                    // const totalQtyForRate = cartarray
                    //     .filter(cartItem => rate.pricingCategoryIds.includes(cartItem.catId))
                    //     .reduce((sum, cartItem) => sum + cartItem.qty, 0);

                    const totalQtyForRate = cartarray
                        .filter(cartItem => rate.pricingCategoryIds.includes(cartItem.catId))
                        .reduce((sum, cartItem) => {
                            // If category is "GROUP", multiply qty by groupSize
                            const adjustedQty = cartItem.cat === "GROUP" ? Number(cartItem.qty) * Number(cartItem.groupSize) : cartItem.qty;
                            return sum + adjustedQty;
                        }, 0);

                    // Ensure the total quantity does not exceed maxPerBooking
                    if (rate.maxPerBooking == null) {
                        return true;
                    }
                    return hasAllCategories && totalQtyForRate <= rate.maxPerBooking;
                });

                // Only return the item if it has valid rates
                return matchingRates?.length > 0 ? { ...item, rates: matchingRates } : null;
            })
            .filter(Boolean); // Remove null values (items with no matching rates)
    }

    function filterRecords(main, cartarray) {
        // console.log('cartarray', cartarray);

        return main
            .map(item => {
                const matchingRates = item?.rates?.filter(rate => {
                    const hasAllCategories = cartarray.every(cartItem =>
                        rate.pricingCategoryIds.includes(cartItem.catId)
                    );

                    const totalQtyForRate = cartarray
                        .filter(cartItem => rate.pricingCategoryIds.includes(cartItem.catId))
                        .reduce((sum, cartItem) => {
                            const adjustedQty = cartItem.cat === "GROUP" ? Number(cartItem.qty) * Number(cartItem.groupSize) : cartItem.qty;
                            return sum + adjustedQty;
                        }, 0);

                    // ✅ Tiered Pricing Check
                    let tieredValid = true;
                    if (rate.tieredPricingEnabled && Array.isArray(rate.tiers)) {
                        // console.log(rate.tiers);

                        for (const cartItem of cartarray) {
                            const tierAry = rate.tiers.filter(t =>
                                t.pricingCategoryId === cartItem.catId &&
                                t.activityRateId === rate.id &&
                                t.maxPassengersRequired != null &&
                                (cartItem.qty >= t.minPassengersRequired && cartItem.qty <= t.maxPassengersRequired)

                            );
                            // console.log('tierAry', tierAry);


                            var tier = null;
                            if (tierAry && tierAry.length > 0) {
                                tier = tierAry[0];
                            }


                            if (tier) {
                                const adjustedQty = cartItem.cat === "GROUP" ? (Number(cartItem.qty) * Number(cartItem.groupSize)) : cartItem.qty;
                                const min = Number(tier.minPassengersRequired) || 0;
                                const max = Number(tier.maxPassengersRequired);
                                if (adjustedQty < min || adjustedQty > max) {
                                    tieredValid = false;
                                    break;
                                }
                            } else {
                                const tierWithMax = rate.tiers.find(t =>
                                    t.pricingCategoryId === cartItem.catId &&
                                    t.activityRateId === rate.id &&
                                    t.maxPassengersRequired != null
                                );

                                if (tierWithMax) {
                                    return null;
                                } else {
                                    // return null;
                                }
                                // return null // If max is not null
                            }
                        }
                    }

                    let availabilityCount = item?.availabilityCount ? item?.availabilityCount : null
                    const isSeatsAvailable = availabilityCount ? (totalQtyForRate <= availabilityCount ? true : false) : true


                    // Return true only if all conditions are met
                    if (rate.maxPerBooking == null || rate.maxPerBooking == 0) {
                        return hasAllCategories && tieredValid && isSeatsAvailable;
                    }
                    if (tieredValid) {
                        return hasAllCategories && totalQtyForRate <= rate.maxPerBooking && tieredValid && isSeatsAvailable;
                    }
                    return hasAllCategories && (totalQtyForRate <= rate.maxPerBooking) && isSeatsAvailable
                });

                return matchingRates?.length > 0 ? { ...item, rates: matchingRates } : null;
            })
            .filter(Boolean);
    }



    const onAddOrRemove = async (pricingCat, cat, type, title) => {
        if (disableButtons || isProcessingRef.current) return;
        isProcessingRef.current = true;
        setDisableButtons(true);

        setActiveKey(["0", "1"]);
        setIsAvailabilityLoading(true);
        let cart = [...userCartData];
        let ind = cart.findIndex((e) => e.catId == pricingCat);

        setDate(null);
        setSelectedRate(null);
        setSelectedTime(null);
        setRatesList([])
        setDateSchedule([]);

        if (type == 'add') {
            if (ind != -1) {
                cart[ind]['qty'] += 1;
                cart[ind]['catId'] = pricingCat;
                cart[ind]['cat'] = cat;
                cart[ind]['title'] = title;

                // if (cat == "GROUP") {
                //     cart[ind]['groupSize'] = 1;
                // }

            } else {
                let indx = cart.length;
                cart[indx] = {
                    qty: 1,
                    catId: pricingCat,
                    cat: cat,
                    title: title
                };

                if (cat == "GROUP") {
                    cart[indx]['groupSize'] = 1;
                }
            }
        } else {
            if (ind != -1) {
                if (cart[ind]['qty'] > 1) {
                    cart[ind]['qty'] -= 1;
                } else {
                    cart.splice(ind, 1);
                }
            }
        }

        setUserCartData(cart);

        if (cart.length === 0) {
            setDisableButtons(false);
            isProcessingRef.current = false;
            availabilityRef.current = null;
            resetCalendar(cart);
            setIsAvailabilityLoading(false);
            return false;
        }

        // IF more then one grop then not allow
        let groupCount = cart.filter((c) => c?.cat == 'GROUP')?.length;
        if (groupCount > 1) {
            setDisableButtons(false);
            isProcessingRef.current = false;
            availabilityRef.current = null;
            resetCalendar(cart);
            setIsAvailabilityLoading(false);
            return false;
        }



        // **Store Availability Data Per Product**
        // const currentMonth = new Date().getMonth() + 1;
        // const currentYear = new Date().getFullYear();
        const currentMonth = selectedMonth !== null ? selectedMonth : new Date().getMonth() + 1
        const currentYear = selectedYear !== null ? selectedYear : new Date().getFullYear()

        // console.log('currentMonth [', currentMonth);
        // console.log('currentYear [', currentYear);



        let storedData = JSON.parse(localStorage.getItem('productAvailability')) || {};
        let availabilityData = null;
        let pricingData = null;
        let tieredPricingData = null;
        let productId = recordDetail?.id
        // console.log(recordDetail?.title);




        if (storedData[productId]?.selectedMonth && storedData[productId]?.selectedYear) {
            // console.log('storedData[productId].selectedMonth)',storedData[productId].selectedMonth);
            // console.log('storedData[productId].selectedYear)',storedData[productId].selectedYear);
            // console.log('currentMonth',currentMonth);

            if (
                Number(storedData[productId].selectedMonth) !== Number(currentMonth) ||
                Number(storedData[productId].selectedYear) !== Number(currentYear)
            ) {
                // console.log('de',storedData[productId]);

                delete storedData[productId]; // Remove outdated data
                // console.log('de aa',storedData[productId]);
            }
        }

        // **Check if Product Data is Available & Not Expired**
        if (storedData[productId]) {

            // console.log('yes stored');



            const { availability, pricing, tieredPricing, timestamp } = storedData[productId];
            const timeElapsed = Date.now() - timestamp;

            if (timeElapsed < AvailabilityResetTime) {
                availabilityData = availability;
                pricingData = pricing;
                tieredPricingData = tieredPricing;
            } else {
                delete storedData[productId]; // Remove expired data
            }
        }

        // console.log('cart', cart);


        // **Check if Month or Year Changed**


        // **Fetch New Availability Data if Needed**
        if (!availabilityData || !pricingData) {
            const { availability, pricing, tieredPricing } = await getProductAvailability(currentYear, currentMonth);
            if (availability && pricing) {
                storedData[productId] = {
                    availability,
                    pricing,
                    tieredPricing,
                    timestamp: Date.now(),
                    selectedMonth: currentMonth,
                    selectedYear: currentYear
                };


                try {
                    const dataSize = getByteLength(JSON.stringify(storedData));
                    if (dataSize < helper.maxLocalStorage) {
                        localStorage.setItem('productAvailability', JSON.stringify(storedData));
                    }

                } catch (e) {

                    if (e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
                        localStorage.removeItem('productAvailability');
                        localStorage.setItem('productAvailability', JSON.stringify(storedData));
                    }

                }

                availabilityData = availability;
                pricingData = pricing;
                tieredPricingData = tieredPricing;
            }
        }
        if (availabilityData == null) {
            setDisableButtons(false);
            isProcessingRef.current = false;
            setActiveKey(["0", "1"]);
            availabilityRef.current = null;
            resetCalendar(cart);
            setIsAvailabilityLoading(false);
            return false;
        }
        // console.log('availabilityData', JSON.parse(availabilityData));
        // console.log('cart', cart);


        // **Filter & Update State**
        const result = filterRecords(JSON.parse(availabilityData), cart);

        // console.log('result', result);


        availabilityRef.current = JSON.stringify(result);
        pricingRef.current = pricingData;
        tieredPricingRef.current = tieredPricingData


        fillAvailablitySchedule(JSON.stringify(result), cart);
        setIsAvailabilityLoading(false);
        setDisableButtons(false);
        isProcessingRef.current = false;
        // setActiveKey(["0", "1"]);
    };

    const onClickTime_ = (startTimeId) => { // Without Tiered Pricing
        setSelectedRate(null)
        let startTimeData = dateSchedule.filter((e) => e.startTimeId == startTimeId)
        if (startTimeData.length > 0 && startTimeData[0]?.rates) {
            setSelectedTime(startTimeData[0])
            let rates = startTimeData[0]?.rates;
            if (rates?.length > 0) {

                rates.map((r, i) => {
                    if (r.pricedPerPerson) {
                        let amt = 0
                        userCartData.map((uc, i) => {
                            let pricingAry = pricingRef?.current && JSON.parse(pricingRef?.current).length ? JSON.parse(pricingRef?.current) : [];
                            let catAmt = pricingAry.filter((p) => p.rateId == r.id && p.pricingCategoryId == uc.catId).length > 0 ? pricingAry.filter((p) => p.rateId == r.id && p.pricingCategoryId == uc.catId)[0].amount : 0
                            amt += Number(catAmt) * uc.qty
                        })
                        r.totalPrice = amt
                    } else {
                        let pricingAry = pricingRef?.current && JSON.parse(pricingRef?.current).length ? JSON.parse(pricingRef?.current) : [];
                        let amt = pricingAry.filter((p) => p.rateId == r.id).length > 0 ? pricingAry.filter((p) => p.rateId == r.id)[0].amount : 0
                        r.totalPrice = amt
                    }
                })

            }

            setRatesList(rates)
            if (rates.length > 0) {
                setSelectedRate(rates[0])
                setCancellationPolicy(generateCancellationPolicy(JSON.stringify(rates[0]?.cancellationPolicy), date, startTimeData[0]?.startTime, recordDetail?.product_detail?.time_zone))
            }
        }
        setActiveKey(['0', '1', '2', '3'])

    }

    const onClickTime_2_ = (startTimeId) => { // With Tiered Pricing 1
        setSelectedRate(null)
        let startTimeData = dateSchedule.filter((e) => e.startTimeId == startTimeId)
        if (startTimeData.length > 0 && startTimeData[0]?.rates) {
            setSelectedTime(startTimeData[0])
            let rates = startTimeData[0]?.rates;
            if (rates?.length > 0) {
                // console.log('date', date);
                // console.log('userCartData', userCartData);

                let pricingAry = pricingRef?.current && JSON.parse(pricingRef?.current).length ? JSON.parse(pricingRef?.current) : [];
                let tieredPricingAry = tieredPricingRef?.current && JSON.parse(tieredPricingRef?.current).length ? JSON.parse(tieredPricingRef?.current) : [];

                rates.map((r, i) => {
                    if (r.pricedPerPerson) {
                        let amt = 0
                        userCartData.map((uc, i) => {
                            const tier = r.tiers.find(t =>
                                t.pricingCategoryId === uc.catId &&
                                t.activityRateId === r.id &&
                                t.maxPassengersRequired != null
                            );

                            // console.log('tier', tier);




                            if (r.tieredPricingEnabled && tier) {
                                let match = tieredPricingAry.find(
                                    (p) =>
                                        p.rateId == r.id &&
                                        p.pricingCategoryId == uc.catId &&
                                        date >= p.from &&
                                        date <= (p.to ? p.to : today) &&
                                        (p.minQty <= Number(uc.qty) && p.maxQty >= Number(uc.qty))

                                );
                                // console.log('match', match);

                                let catAmt = match ? match.amount : 0;
                                // let catAmt = tieredPricingAry.filter((p) => p.rateId == r.id && p.pricingCategoryId == uc.catId).length > 0 ? tieredPricingAry.filter((p) => p.rateId == r.id && p.pricingCategoryId == uc.catId)[0].amount : 0
                                amt += Number(catAmt) * uc.qty
                            } else {
                                let match = pricingAry.find(
                                    (p) =>
                                        p.rateId == r.id &&
                                        p.pricingCategoryId == uc.catId &&
                                        date >= p.from &&
                                        date <= (p.to ? p.to : today)
                                );
                                let catAmt = match ? match.amount : 0;


                                // let catAmt = pricingAry.filter((p) => p.rateId == r.id && p.pricingCategoryId == uc.catId).length > 0 ? pricingAry.filter((p) => p.rateId == r.id && p.pricingCategoryId == uc.catId)[0].amount : 0
                                amt += Number(catAmt) * uc.qty
                            }

                        })
                        r.totalPrice = amt
                    } else {
                        let match = pricingAry.find(
                            (p) =>
                                p.rateId == r.id &&
                                // p.pricingCategoryId == uc.catId &&
                                date >= p.from &&
                                date <= (p.to ? p.to : today)
                        );
                        let catAmt = match ? match.amount : 0;
                        r.totalPrice = catAmt
                        // let amt = pricingAry.filter((p) => p.rateId == r.id).length > 0 ? pricingAry.filter((p) => p.rateId == r.id)[0].amount : 0
                        // r.totalPrice = amt
                    }
                })

            }

            setRatesList(rates)
            if (rates.length > 0) {
                setSelectedRate(rates[0])
                setCancellationPolicy(generateCancellationPolicy(JSON.stringify(rates[0]?.cancellationPolicy), date, startTimeData[0]?.startTime, recordDetail?.product_detail?.time_zone))
            }
        }
        setActiveKey(['0', '1', '2', '3'])

    }

    const onClickTime = (startTimeId) => { // With Tiered Pricing final 
        setSelectedRate(null)
        let validRates = [];
        let startTimeData = dateSchedule.filter((e) => e.startTimeId == startTimeId)
        // console.log('startTimeData',startTimeData.length);

        if (startTimeData.length > 0 && startTimeData[0]?.rates) {
            setSelectedTime(startTimeData[0])
            let rates = startTimeData[0]?.rates;
            console.log('chi rates', rates);

            if (rates?.length > 0) {

                let pricingAry = pricingRef?.current && JSON.parse(pricingRef?.current).length ? JSON.parse(pricingRef?.current) : [];
                let tieredPricingAry = tieredPricingRef?.current && JSON.parse(tieredPricingRef?.current).length ? JSON.parse(tieredPricingRef?.current) : [];

                rates.map((r, i) => {
                    let rateHasMatch = false;



                    if (r.pricedPerPerson) {
                        let amt = 0
                        userCartData.map((uc, i) => {

                            const tier = r.tiers.find(t =>
                                t.pricingCategoryId === uc.catId &&
                                t.activityRateId === r.id
                                && t.maxPassengersRequired != null
                            );
                            console.log('chi tier', tier);
                            if (r.tieredPricingEnabled && tier) {
                                console.log('chi tieredPricingAry', tieredPricingAry);
                                // console.log('pricingAry',pricingAry);



                                // let match = tieredPricingAry.find(
                                //     (p) =>
                                //         p.rateId == r.id &&
                                //         p.pricingCategoryId == uc.catId &&
                                //         date >= p.from &&
                                //         date <= (p.to ? p.to : today) &&
                                //         // (p.minQty >= Number(uc.qty) && p.maxQty >= Number(uc.qty))
                                //         // (uc.qty >= Number(p.minQty) && uc.qty >= Number(p.maxQty))
                                //         (
                                //             p.maxQty != null ?
                                //                 uc.qty >= Number(p.minQty) && uc.qty >= Number(p.maxQty) : true)

                                //     // (cartItem.qty >= t.minPassengersRequired && cartItem.qty <= t.maxPassengersRequired)

                                // );
                                let match = tieredPricingAry.find((p) => {
                                    const minKey = 'minQty' in p ? 'minQty' : 'minPassengersRequired';
                                    const maxKey = 'maxQty' in p ? 'maxQty' : 'maxPassengersRequired';

                                    return (
                                        p.rateId == r.id &&
                                        p.pricingCategoryId == uc.catId &&
                                        date >= p.from &&
                                        date <= (p.to ? p.to : today) &&
                                        // uc.qty >= Number(p[minKey]) &&
                                        // uc.qty <= Number(p[maxKey])
                                        (p[maxKey] != null ?
                                            uc.qty >= Number(p[minKey]) && uc.qty <= Number(p[maxKey]) : true
                                        )
                                    );
                                });
                                // console.log('match', match);


                                if (match) {
                                    let catAmt = match.amount;
                                    amt += Number(catAmt) * uc.qty;
                                    rateHasMatch = true;
                                }

                            } else {
                                let match = pricingAry.find(
                                    (p) =>
                                        p.rateId == r.id &&
                                        p.pricingCategoryId == uc.catId &&
                                        date >= p.from &&
                                        date <= (p.to ? p.to : today) &&
                                        // (uc.qty >= Number(r.minPerBooking) && uc.qty >= Number(r.maxPerBooking))
                                        (r.maxPerBooking != null ?
                                            uc.qty >= Number(r.minPerBooking) && uc.qty <= Number(r.maxPerBooking) : true
                                        )
                                );
                                // console.log('match', match);
                                // console.log('pricingAry', pricingAry);



                                if (match) {
                                    let catAmt = match.amount;
                                    amt += Number(catAmt) * uc.qty;
                                    rateHasMatch = true;
                                }
                            }

                        })
                        if (rateHasMatch) {
                            r.totalPrice = amt;
                            validRates.push(r);
                        }
                    } else {
                        // console.log('pricingAry', pricingAry);
                        // console.log('userCartData', userCartData);
                        // console.log('r', r);


                        userCartData.map((uc, i) => {
                            let match = pricingAry.find(
                                (p) =>
                                    p.rateId == r.id &&
                                    date >= p.from &&
                                    date <= (p.to ? p.to : today) &&
                                    // (uc.qty >= Number(r.minPerBooking) && uc.qty >= Number(r.maxPerBooking))
                                    (r.maxPerBooking != null ?
                                        uc.qty >= Number(r.minPerBooking) && uc.qty <= Number(r.maxPerBooking) : true
                                    )

                            );

                            if (match) {
                                r.totalPrice = match.amount;
                                validRates.push(r);
                            }

                        })
                    }
                })

            }

            setRatesList(validRates)
            if (validRates.length > 0) {
                setSelectedRate(validRates[0])
                setCancellationPolicy(generateCancellationPolicy(JSON.stringify(validRates[0]?.cancellationPolicy), date, startTimeData[0]?.startTime, recordDetail?.product_detail?.time_zone))
            }
        }
        setActiveKey(['0', '1', '2', '3'])

    }

    const onClickRate = (rate) => {
        setSelectedRate(rate)
        setCancellationPolicy(generateCancellationPolicy(JSON.stringify(rate?.cancellationPolicy), date, selectedTime?.startTime, recordDetail?.product_detail?.time_zone))
    }

    const onChangeGroupSize = async (ind, val) => {
        let cart = [...userCartData]
        cart[ind]['groupSize'] = Number(val)
        setUserCartData(cart)


        const currentMonth = selectedMonth !== null ? selectedMonth : new Date().getMonth() + 1
        const currentYear = selectedYear !== null ? selectedYear : new Date().getFullYear()

        let storedData = JSON.parse(localStorage.getItem('productAvailability')) || {};
        let availabilityData = null;
        let pricingData = null;
        let tieredPricingData = null;
        let productId = recordDetail?.id

        if (storedData[productId]?.selectedMonth && storedData[productId]?.selectedYear) {

            if (
                Number(storedData[productId].selectedMonth) !== Number(currentMonth) ||
                Number(storedData[productId].selectedYear) !== Number(currentYear)
            ) {

                delete storedData[productId];
            }
        }


        if (storedData[productId]) {
            const { availability, pricing, tieredPricing, timestamp } = storedData[productId];
            const timeElapsed = Date.now() - timestamp;

            if (timeElapsed < AvailabilityResetTime) {
                availabilityData = availability;
                pricingData = pricing;
                tieredPricingData = tieredPricing;
            } else {
                delete storedData[productId]; // Remove expired data
            }
        }

        if (!availabilityData || !pricingData) {
            const { availability, pricing, tieredPricing } = await getProductAvailability(currentYear, currentMonth);
            if (availability && pricing) {
                storedData[productId] = {
                    availability,
                    pricing,
                    timestamp: Date.now(),
                    selectedMonth: currentMonth,
                    selectedYear: currentYear
                };

                localStorage.setItem('productAvailability', JSON.stringify(storedData));

                availabilityData = availability;
                pricingData = pricing;
                tieredPricingData = tieredPricing;

            }
        }
        if (availabilityData == null) {
            setActiveKey(["0", "1"]);
            availabilityRef.current = null;
            resetCalendar(cart);
            setIsAvailabilityLoading(false);
            return false;
        }

        const result = filterRecords(JSON.parse(availabilityData), cart);

        availabilityRef.current = JSON.stringify(result);
        pricingRef.current = pricingData;
        tieredPricingRef.current = tieredPricingData

        fillAvailablitySchedule(JSON.stringify(result), cart);
        setIsAvailabilityLoading(false);
    }

    const onClickContinue = async () => {
        localStorage.removeItem('mb_way_payment_request_id')
        localStorage.removeItem("mb_payment_request_id");
        dispatch(setCartClear())
        if (userCartData.length == 0) {
            ToastAlert({ msg: 'Please select People', msgType: 'error' })
            dispatch(setCartClear())
            return false
        }
        if (!date) {
            ToastAlert({ msg: 'Please select Date', msgType: 'error' })
            dispatch(setCartClear())
            return false
        }
        if (!selectedTime) {
            ToastAlert({ msg: 'Please select Time', msgType: 'error' })
            dispatch(setCartClear())
            return false
        }
        if (!selectedRate) {
            ToastAlert({ msg: 'Please select Rate', msgType: 'error' })
            dispatch(setCartClear())
            return false
        }

        let cartData = {}
        cartData.people = userCartData
        cartData.activityId = recordDetail?.tour_provider_product_id
        cartData.date = date
        cartData.startTimeId = selectedTime.startTimeId
        cartData.rateId = selectedRate.id
        cartData.type = recordDetail?.tour_provider
        if (cart.cartSession) {
            cartData.cartSession = cart.cartSession
        }

        dispatch(setLoading(true))
        const addToCart = await ApiCall('post', 'add-to-cart', cartData)
        dispatch(setLoading(false))
        if (addToCart) {
            if (addToCart?.data?.success) {

                let data = {};
                data.people = userCartData
                // data.product = recordDetail
                data.product = recordDetail?.id
                data.selectedDate = date
                data.selectedRate = selectedRate
                data.selectdTime = selectedTime
                // data.priceList = pricingRef?.current
                data.cartSession = addToCart.data.cartSession

                const userlang = getSlugByLang(user?.language);
                dispatch(setCartList(data))
                navigate('/' + userlang + '/checkout')
            } else {

                if (addToCart?.data?.errors && Object.keys(addToCart?.data?.errors)?.length) {

                    Object.keys(addToCart.data.errors).map((e, i) => {
                        ToastAlert({ msg: addToCart.data.errors[e], msgType: 'error' })
                        return false
                    })


                } else {

                    if (addToCart.data?.message?.message) {

                        // console.log(addToCart.data?.message.fields.insufficientAvailabilities);
                        if (addToCart.data?.message?.fields?.insufficientAvailabilities?.length > 0) {
                            let leftSheets = addToCart.data?.message?.fields?.insufficientAvailabilities[0]?.availabilitiesLeft
                            ToastAlert({ msg: "Seats running out! Only " + leftSheets + " left!", msgType: 'error' })

                        }



                    } else {
                        ToastAlert({ msg: addToCart?.data?.message, msgType: 'error' })
                    }
                }

            }
        }
    }

    // console.log('cart', cart);
    // console.log(perems);


    // console.log(recordDetail?.[getTitleNameByLang(user?.language)]);

    useEffect(() => {
        if (locationDetail != null || (locationDetail && locationDetail.length > 0)) {
            const slugLang = getSlugByLang(user?.language)
            const slugLinkField = getLinkNameByLang(user?.language)
            let breadCrmb = [
                {
                    name: <HomeIcon />,
                    url: (slugLang ? ('/' + slugLang) : '/en')
                }
            ];
            if (locationDetail.length > 0) {
                locationDetail.map((loc, i) => {
                    breadCrmb.push({
                        name: loc.name,
                        // url: '/location' + loc.link
                        url: (slugLang ? ('/' + slugLang) : '') + '/location' + loc?.[slugLinkField]

                    })
                })
                setBreadcrumbList(breadCrmb)
            }

        }
    }, [user?.language]);

    useEffect(() => {
        // Check if the script is already loaded to avoid loading it multiple times

        const script = document.createElement('script');
        script.src = 'https://cdn.trustindex.io/loader.js';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);

        // Cleanup: Remove the script when the component is unmounted
        return () => {
            document.head.removeChild(script);
        };
    }, [recordDetail, productList, similarTours]);


    console.log('NEW VERSION V5')

    // console.log('selectedRate',selectedRate);
    



    return (
        <>
            <PageTitle
                title={metaTitle || 'Loading...'}
                metaTitle={metaTitle ?? undefined}
                metaDescription={metaTitle ?? undefined}
                metaKeyword={metaTitle ?? undefined}
                image={helper.S3Url + '/' + helper.productImageDir + '/' + recordDetail?.cover_image}
            // script={<script src='https://cdn.trustindex.io/loader.js'></script>}
            />
            <Index
                isAdultDropBoxVisible={isAdultDropBoxVisible}
                toggleDropBox={toggleDropBox}
                adultDropBoxRef={adultDropBoxRef}
                isDateDropBoxVisible={isDateDropBoxVisible}
                dateDropBoxRef={dateDropBoxRef}
                calendarRef={calendarRef}
                isTimeDropBoxVisible={isTimeDropBoxVisible}
                timeDropBoxRef={timeDropBoxRef}
                toggleMap={toggleMap}
                isLoading={isLoading}
                recordDetail={recordDetail}
                mapLoaded={mapLoaded}
                breadcrumbList={breadcrumbList}
                isProductLiked={isProductLiked}
                toggleLike={toggleLike}
                onClickShareIcon={onClickShareIcon}
                expanded={expanded}
                setExpanded={setExpanded}
                descriptionRef={descriptionRef}
                isOverflowing={isOverflowing}
                isAdminLoggedin={isAdminLoggedin}
                companyDetail={companyDetail}
                supplierDetail={supplierDetail}
                setIsDateDropBoxVisible={setIsDateDropBoxVisible}
                date={date}
                activeKey={activeKey}
                closeAccordion={closeAccordion}
                setActiveKey={setActiveKey}
                isAvailabilityLoading={isAvailabilityLoading}
                dateSchedule={dateSchedule}
                slotNotAvailabel={slotNotAvailabel}
                toggleAccordion={toggleAccordion}
                onAddOrRemove={onAddOrRemove}
                productPricingCategories={productPricingCategories}
                userCartData={userCartData}
                onClickTime={onClickTime}
                ratesList={ratesList}
                selectedTime={selectedTime}
                onClickRate={onClickRate}
                selectedRate={selectedRate}
                pricingRef={pricingRef}
                tieredPricingRef={tieredPricingRef}
                onChangeGroupSize={onChangeGroupSize}

                isSimilarTourLoading={isSimilarTourLoading}
                similarTours={similarTours}
                flatpickrInstance={flatpickrInstance}

                onClickContinue={onClickContinue}
                cancellationPolicy={cancellationPolicy}


                productList={productList}
                onClickLoadMore={onClickLoadMore}
                supplierProductNextPageUrl={supplierProductNextPageUrl}
                isDefLoading={isDefLoading}
                isSupplierProductLoading={isSupplierProductLoading}

                toggleRealExpMap={toggleRealExpMap}
                realExpMapLoaded={realExpMapLoaded}
                today={today}

                togglePlace={togglePlace}

                handleSeePlacesLessClick={handleSeePlacesLessClick}
                handleSeePlacesMoreClick={handleSeePlacesMoreClick}
                showAllPlaces={showAllPlaces}


                isPickupLoading={isPickupLoading}
                pickupNextPageUrl={pickupNextPageUrl}
                pickupList={pickupList}
                onClickLoadMorePickup={onClickLoadMorePickup}
                disableButtons={disableButtons}

                toggleRouteMap={toggleRouteMap}
                routeMapLoaded={routeMapLoaded}
                isDefLoadingPickup={isDefLoadingPickup}



            />
        </>
    )
}